
import { CanMatchFn, Route, UrlSegment, Router } from '@angular/router';
import { inject } from '@angular/core';

export const urlValidatorGuard: CanMatchFn = (
    route: Route,
    segments: UrlSegment[]
) => {
    const router = inject(Router);

    const fullPath = '/' + segments.map(s => decodeURIComponent(s.path)).join('/');

    const validPatterns = [
        /^\/$/,                                                  // home
        /^\/[a-zA-Z0-9-%آ-ی]+-hotels\/?$/,                        // /city-hotels
        /^\/[a-zA-Z0-9-%آ-ی]+-hotels\/[^/]+\/?$/,                 // /city-hotels/hotel
        /^\/ecolodge\/[^/]+\/?$/,                                 // /ecolodge/type or city
        /^\/ecolodge\/[^/]+\/map\/?$/,                            // /ecolodge/type/map
        /^\/[a-zA-Z0-9-%آ-ی]+\/map\/?$/,                          // /city/map
        /^\/[a-zA-Z0-9-%آ-ی]+\/(star\d+|[a-zA-Z0-9-]+-rec)\/?$/,  // /city/star5 or rec
        /^\/[a-zA-Z]{3}\/?$/,                        // ✅ /tur
        /^\/[a-zA-Zآ-ی0-9%]{3}\/[^/]+\/?$/,                        // ✅ /tur/istanbul
        /^\/[a-zA-Z0-9-%آ-ی]+\/[^/]+\/[^/]+\/?$/,                 // /country/city/resident
        /^\/[a-zA-Z0-9-]+-hotels\/[\u0600-\u06FFa-zA-Z0-9-%]+\/?$/,
        /^\/[a-zA-Z0-9-]+-hotels\/[\u0600-\u06FFa-zA-Z0-9\-–—ـ_%\s]+\/?$/,
        
    ];

    const isValid = validPatterns.some(p => p.test(fullPath));
    if (!isValid) {
        router.navigateByUrl('/notfound');
        return false;
    }

    return true;
};
